import * as Multiselect from '../../../../components/blocks/multiselect/main';
import {SelectionModel} from './partner-selection-model';
import {SearchUrl}      from './partner-search-url';


export function init(searchUrl: SearchUrl) {
  const mainElm           = document.querySelector('#block-system-main')          as HTMLElement;
  const textWidgetElms    = Array.from(document.querySelectorAll('.multiselect')) as HTMLElement[];
  const selectionModelElm = document.getElementById('selection-model')            as HTMLScriptElement;
  const counterElm        = document.getElementById('search-counter')             as HTMLElement;
  
  let selectionModel      = new SelectionModel(selectionModelElm, counterElm, searchUrl);
  
  // Init all multiselect widgets
  updateAllItemStates();
  for (const widget of textWidgetElms) {
    Multiselect.init(widget);
  }
  
  // Update model, counter and active/inactive checkboxes if a checkbox has been selected.
  mainElm.addEventListener('checkboxEvent', ((event: CustomEvent) => {
    selectionModel.toggleChecked(event.detail.id);
    updateAllItemStates();
  }) as EventListener);

  // Update counter and active/inactive checkboxes based on the model.
  function updateAllItemStates() {
    for (let selection of selectionModel.selections) {
      for (let criterion of selection.criteria) {
        const id      = criterion.id.toString();
        const state   = criterion.count != 0;
        const checked = criterion.checked;
        Multiselect.updateItemState(id, state, checked);
      }
    }
    counterElm.innerHTML = selectionModel.activeNodeAmount.toString();
  }

}



